"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfPriceDropAlertListItemDto = instanceOfPriceDropAlertListItemDto;
exports.PriceDropAlertListItemDtoFromJSON = PriceDropAlertListItemDtoFromJSON;
exports.PriceDropAlertListItemDtoFromJSONTyped = PriceDropAlertListItemDtoFromJSONTyped;
exports.PriceDropAlertListItemDtoToJSON = PriceDropAlertListItemDtoToJSON;
exports.PriceDropAlertListItemDtoToJSONTyped = PriceDropAlertListItemDtoToJSONTyped;
var PriceDropAlertUserDto_1 = require("./PriceDropAlertUserDto");
/**
 * Check if a given object implements the PriceDropAlertListItemDto interface.
 */
function instanceOfPriceDropAlertListItemDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('listingId' in value) || value['listingId'] === undefined)
        return false;
    if (!('alertPrice' in value) || value['alertPrice'] === undefined)
        return false;
    if (!('isActive' in value) || value['isActive'] === undefined)
        return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined)
        return false;
    if (!('user' in value) || value['user'] === undefined)
        return false;
    return true;
}
function PriceDropAlertListItemDtoFromJSON(json) {
    return PriceDropAlertListItemDtoFromJSONTyped(json, false);
}
function PriceDropAlertListItemDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'listingId': json['listingId'],
        'alertPrice': json['alertPrice'],
        'isActive': json['isActive'],
        'createdAt': json['createdAt'],
        'user': (0, PriceDropAlertUserDto_1.PriceDropAlertUserDtoFromJSON)(json['user']),
    };
}
function PriceDropAlertListItemDtoToJSON(json) {
    return PriceDropAlertListItemDtoToJSONTyped(json, false);
}
function PriceDropAlertListItemDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'listingId': value['listingId'],
        'alertPrice': value['alertPrice'],
        'isActive': value['isActive'],
        'createdAt': value['createdAt'],
        'user': (0, PriceDropAlertUserDto_1.PriceDropAlertUserDtoToJSON)(value['user']),
    };
}
